Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appbaseRefReducer;

var _constants = require('../constants');

function appbaseRefReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action.type === _constants.ADD_APPBASE_REF) {
    return action.appbaseRef;
  }

  return state;
}